export default __webpack_public_path__ + "static/media/p2.1102e33a.jpg";